import React, {Component} from 'react'
import { Progress, Icon } from 'semantic-ui-react'

class ReadingIndicator extends Component {
    render() {
        return (
            <div>
                <span className="uploadIcons">
                    <Icon name="folder open outline" />
                </span>
                <div className="uploadProgressBar">
                    <Progress percent={this.props.percentage} indicating />
                </div>
                <h4 className="thinHeading">Reading Files...</h4>
            </div>
        )
    }
}

export default ReadingIndicator